export default __webpack_public_path__ + "locales/ro/Files.json?hash=430d471779870f48241cc56c2650c002";